import { Directive, HostListener, inject, input } from '@angular/core';
import { copyToClipboard } from '@fc-shared/utils/data.utils';
import { NotificationService } from '@fc-core';

@Directive({
  selector: '[fcCopyToClip]',
  standalone: true,
})
export class CopyToClipDirective {
  notifications = inject(NotificationService);
  text = input.required<string>();

  @HostListener('mousedown')
  onClick() {
    copyToClipboard(this.text());
    this.notifications.showSuccess('Copied to clipboard');
  }
}
